import { OrStatsList } from './or-stats-list';
import { IOrStatsListCMSProps, TStat, TStatCMS } from './or-stats-list.types';

const parseStatsFromCMS = (cmsStats: TStatCMS[]): TStat[] => {
  return cmsStats.map(({ heading, subtitle }) => ({
    title: heading,
    subtitle,
  }));
};

export const OrStatsListCMS = ({
  variant,
  stats: cmsStats,
  top_spacing,
  bottom_spacing,
}: IOrStatsListCMSProps) => {
  if (!variant || !cmsStats) return <></>;

  return (
    <OrStatsList
      variant={variant}
      stats={parseStatsFromCMS(cmsStats)}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
    />
  );
};
